import React, {Component} from "react";
import TopBar from "../../component/projectDetail/TopBar";
import Banner from "../../component/projectDetail/Banner";
import RightPanel from "../../component/projectDetail/RightPanel";
import axios from "axios";
import {authService} from "../../../auth";
import * as _ from "lodash";
import {setProjectDetails} from "../../../reducer/showAllReducer";
import {connect} from "react-redux";
import mappingUtils from "../../component/commons/utils/mappingUtils";
import {getCDNUrl, getOptimizedImage} from "../../../commons/CommonFunctions";
import {isMobileDevice} from "../../../commons/CommonFunctions";
import HorizontalScroll from 'react-scroll-horizontal';
import Loader from "react-loader-spinner";
import {Scrollbars} from "react-custom-scrollbars";
import {Link} from "react-router-dom";
import withReactContent from "sweetalert2-react-content";
import alertPopUp from "sweetalert2";
import OrganizationAdmin from "../../../commons/OrganizationAdmin";
import CleverTapUtils from "../../../commons/CleverTapUtils";
const ErorrMsgPopUp = withReactContent(alertPopUp);

if (isMobileDevice()) {
    import('../../../commons/styles/responsive-useragent.css').then(() => {
       console.log("Imported mobile css");
    });
}

class ProjectAdminContainer extends Component {

    constructor(props) {
        super(props);
        this.state = {
            userData: authService.getUserDetailsFromLocalStorage(),
            pageSize: 6,
            pageNo: 0,
            user: {},
            userId: '',
            pagination: false,
            project: props.project,
            faculties: [],
            projectDetail: {},
            selectedList:[],
            visibleToUserIds: [],
            searchUserByChars: '',
            config:{},
            administrations:[],
            pendingInvitations:{},
            adminHistory:{},
            adminInfo:{},
            searchMembers: '',
            subscriptionConfig:{},
            subscriptionError:false,
            subscriptionErrorMessage:''
        }

    }

    componentDidMount() {
        window.$(".outsdinvfrndhdr").click(function () {
            window.$(".outsdinvfrndbdy").slideToggle("slow");
            window.$(".outsdinvfrndhdr").toggleClass("active");
        });
        this.getCurrentAdministrations();
        this.getAdminConfig();
        this.getPendingInvitations();
        this.getAdminHistory();
        this.getSubscriptionEntityConfig();

        window.$('.projgeneralsec .collapse').on('shown.bs.collapse', function () {
            window.$(this).parent().addClass('active');
        });

        window.$('.projgeneralsec .collapse').on('hidden.bs.collapse', function () {
            window.$(this).parent().removeClass('active');
        });
    }

    getSubscriptionEntityConfig = () => {
        let postBody = {
            "userId": authService.getUserDetailsFromLocalStorage().userId,
            "entityId": this.props.projectId,
            "entityType": 'PROJECT',

        };
        axios({
            method: 'post',
            url: process.env.REACT_APP_userServiceURL +
                "/user/subscription/entity/config" ,
            data: postBody,
            headers: {'Content-Type': 'application/json'},

            withCredentials: true
        }).then((response) => {
            let res = response.data;
            if (res.status === '200 OK') {
                this.setState({'subscriptionConfig': res.body})
            }

        }).catch((err) => {
            if (err && err.response) {
                this.setState({
                    error: {message: err.response.data.message, err: err.response}
                })
            }
            this.setState({
                isLoaded: true
            });
        });
    };

    componentWillUnmount() {
        window.$('#confirmPopupInvite' + this.state.uniqueKeyInvite + this.state.currentIndex).modal('hide');
        window.$('#projectDetails').modal('hide');
        window.$('#confirmPopupPending' + this.state.uniqueKeyPending).modal('hide')
    }

    componentWillReceiveProps(nextProps) {
        if (this.state.projectDetail !== nextProps.projectDetail) {
            this.setState({'projectDetail': nextProps.projectDetail}, () => {
                window.$(".outsdinvfrndhdr").click(function () {
                    window.$(".outsdinvfrndbdy").slideToggle("slow");
                    window.$(".outsdinvfrndhdr").toggleClass("active");
                });


            });
        }

    }

    submitUser = (event) => {
        event.preventDefault();
        this.setState({'user':{}, radioChecked:false,searchMembers:'' ,isDisable : true, userId : ''
        })
        window.$('#assignsinglepopAdmin').modal('hide');

    }

    openRemoveConfirmPop = (data) => {
        this.setState({'adminId':data.userId,'adminInfo':data});
        window.$('#removeAdminConfirmPop').modal('show');

    }

    openAdminTransferModel = (event)=>{
        CleverTapUtils.eventClick({}, "Transfer Admin Rights");
        if(this.state.config && !this.state.config.studioUserAvailable && !this.state.config.notElligibleForTrasferDueToDonation){
            window.$('#assignsinglepopAdmin').modal('show');
        }else{
            ErorrMsgPopUp.fire({
                didOpen: () => {
                    ErorrMsgPopUp.clickConfirm();
                }
            }).then((result) => {
                return ErorrMsgPopUp.fire({
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                    title: <><p>You cannot transfer the project while {this.state.config?.notElligibleForTrasferDueToDonation ? "fund raise is active." : "studio is active."}</p></>
                })
            })
        }

    }

    cancelUser = (event) =>{
        event.preventDefault();
        this.setState({'user':{}, radioChecked:false,searchMembers:'' ,isDisable : true, userId : ''}, () => {
            window.$('#assignsinglepopAdmin').modal('hide');
        })
    }

    addMember=(user)=>{
        this.setState({'user':user , userId : user.id}, () => {
            if (this.state.user.id != null) {
                this.setState({isDisable: false});
            } else {
                this.setState({isDisable: true});
            }
        })
    }

    handleSearch=(event)=>{
        this.setState({
            searchMembers: event.target.value
        })
    }

    keyPressedBySearchGroupByChars(event) {
        this.setState({searchUserByChars: event.target.value});
    }

    addUserToGroup(evt, data) {
        let selectedList = this.state.selectedList;
        selectedList.push(data);
        let array = [...this.state.userList];
        let index = array.indexOf(data)
        if (index !== -1) {
            array.splice(index, 1);
            this.setState({userList: array});
        }
        this.setState({selectedList: selectedList});
        evt.preventDefault();
    }

    redirectToProfile = (customUrl) => {
        window.location.href = "/profile/" + customUrl;
    }

    getOptimizedImage(data) {
        if (data.resizedProfileImages && data.resizedProfileImages['200x200'] != null) {
            return data.resizedProfileImages['200x200'];
        }
        return data.originalProfileImage;
    }

    clearUsers() {
        document.getElementById('searchGroupByChars').value = '';
        this.setState({selectedList: [], searchUserByChars: ''});
        this.getAdminConfig();
    }

    handleUsersSelectSubmit = (event) => {
        event.preventDefault();
        let userIds = [];
        for (let data of this.state.selectedList) {
            userIds.push(data.id);
        }

        document.getElementById('searchGroupByChars').value = '';
        let maxParticipants = this.state.subscriptionConfig.maxAdmins - this.state.subscriptionConfig.multiPleAdmins;
        if(userIds.length<=maxParticipants) {
            let postBody = {

                "entityId": this.props.projectId,
                "entityType": 'PROJECT',
                "superAdminId": this.state.userData.userId,
                "adminIds": userIds
            };
            axios({
                method: 'post',
                url: process.env.REACT_APP_userServiceURL + '/backend/admin/create',
                headers: {'Content-Type': 'application/json'},
                data: postBody,
                withCredentials: true
            }).then((response, dispatch) => {
                let res = response.data;
                if (res.status === '201 CREATED') {
                    this.setState({selectedList: [], searchUserByChars: ''});
                    window.$('#addAdminModal').modal('hide')
                    this.getAdminConfig();
                    this.getSubscriptionEntityConfig();
                    this.getCurrentAdministrations();
                    this.getPendingInvitations();
                    this.getAdminHistory();

                }
            }).catch((err) => {

            });
        }else{

                ErorrMsgPopUp.fire({
                    didOpen: () => {
                        ErorrMsgPopUp.clickConfirm();
                    }
                }).then((result) => {
                    return ErorrMsgPopUp.fire({
                        allowOutsideClick: false,
                        allowEscapeKey: false,
                        title: <><p>{maxParticipants>0?'You can not send more than '+maxParticipants+' as per subscription policy.':'You have reached the maximum limit of allowed Admins.'}</p><a class="styleBtn" href={'/wenaturalists-pro'}>Upgrade your Membership</a>{/* <div className='registerFreetrial'><a href='/wenaturalists-pro'>Register for a Free Trial</a></div> */}</>,
                    })
                })



           /* this.setState({'subscriptionError': true, 'subscriptionErrorMessage':maxParticipants>0? 'you can not send more than '+maxParticipants+' as per subscription policy':'You have reached the maximum limit of allowed Admins. Upgrade your Membership.'});
            setTimeout(() => {
                this.setState({'subscriptionError': false, 'subscriptionErrorMessage':''});
            }, 10000);*/

        }


    };

    removeAdmin = () => {

        let postBody = {
            "entityId": this.props.projectId,
            "adminId": this.state.adminId,
            "superAdminId": this.state.userData.userId
        };
        axios({
            method: 'post',
            url: process.env.REACT_APP_userServiceURL + '/backend/admin/remove',
            headers: {'Content-Type': 'application/json'},
            data: postBody,
            withCredentials: true
        }).then((response, dispatch) => {
            let res = response.data;
            if (res.status === '201 CREATED') {
                window.$('#removeAdminConfirmPop').modal('hide');
                this.getAdminConfig();
                this.getCurrentAdministrations();
                this.getPendingInvitations();
                this.getAdminHistory();

            }
        }).catch((err) => {

        });

    };

    transferAdminRightRequest = (event) => {
        event.preventDefault();
        let postBody = {
            "entityId": this.props.projectId,
            "adminId": this.state.userId,
            "superAdminId": this.state.userData.userId,
            "remainAdmin" :false
        };
        axios({
            method: 'post',
            url: process.env.REACT_APP_userServiceURL + '/backend/admin/transfer/right',
            headers: {'Content-Type': 'application/json'},
            data: postBody,
            withCredentials: true
        }).then((response, dispatch) => {
            let res = response.data;
            if (res.status === '201 CREATED') {
                window.$('#assignsinglepopAdmin').modal('hide')
                this.getAdminConfig();
                this.getCurrentAdministrations();
                this.getPendingInvitations();
                this.getAdminHistory();

            }
        }).catch((err) => {

        });

    };

    withDrawInviteRequest = (adminId) => {
        let postBody = {
            "entityId": this.props.projectId,
            "adminId": adminId,
            "superAdminId": this.state.userData.userId,
        };
        axios({
            method: 'post',
            url: process.env.REACT_APP_userServiceURL + '/backend/admin/withdraw/invite',
            headers: {'Content-Type': 'application/json'},
            data: postBody,
            withCredentials: true
        }).then((response, dispatch) => {
            let res = response.data;
            if (res.status === '202 ACCEPTED') {
                window.$('#withdrawInvite'+adminId).modal('hide')
                this.getAdminConfig();
                this.getCurrentAdministrations();
                this.getPendingInvitations();
                this.getAdminHistory();

            }
        }).catch((err) => {

        });

    };

    withDrawTransferInviteRequest = (adminId) => {
        let postBody = {
            "entityId": this.props.projectId,
            "superAdminId": this.state.userData.userId,
        };
        axios({
            method: 'post',
            url: process.env.REACT_APP_userServiceURL + '/backend/admin/withdraw/transfer/invite',
            headers: {'Content-Type': 'application/json'},
            data: postBody,
            withCredentials: true
        }).then((response, dispatch) => {
            let res = response.data;
            if (res.status === '202 ACCEPTED') {
                window.$('#withdrawTransferInvite').modal('hide')
                this.getAdminConfig();
                this.getCurrentAdministrations();
                this.getPendingInvitations();
                this.getAdminHistory();

            }
        }).catch((err) => {

        });

    };

    getAdminConfig =()=>{
        axios({
            method: 'get',
            url: process.env.REACT_APP_userServiceURL +
                "/admin/get/config/" + this.state.userData.userId +  "?entityId=" + this.props.projectId,
            headers: {'Content-Type': 'application/json'},
            withCredentials: true
        }).then(response => {
            if (response && response.data && response.data.message === 'Success!') {
                this.setState({
                    userList: response.data.body.inviteeDetails,
                    config:response.data.body
                })
            }
        }).catch((err) => {
            console.log(err);
        });
    }


    handleAddAdmin = (event) => {
        event.preventDefault();
        CleverTapUtils.eventClick({}, "Add Admin");
        this.setState({'isModalLoading': true});
                let selectedList = [];
                if (this.state.userList && this.state.userList.length > 0) {
                    selectedList = this.state.userList.filter(({id}) => this.state.visibleToUserIds.includes(id));
                    selectedList.forEach((data) => {
                        let index = this.state.userList.indexOf(data)
                        if (index !== -1) {
                            this.state.userList.splice(index, 1);
                        }
                    });
                }
                this.setState({userList: this.state.userList, selectedList: selectedList, 'isModalLoading': false}, () => {

                })
        if(this.state.subscriptionConfig && !this.state.subscriptionConfig.canSendAdminRequest){
            ErorrMsgPopUp.fire({
                didOpen: () => {
                    ErorrMsgPopUp.clickConfirm();
                }
            }).then((result) => {
                return ErorrMsgPopUp.fire({
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                    title: <><p>You have reached the maximum limit of allowed Admins.</p><a class="styleBtn" href={'/wenaturalists-pro'}>Upgrade your Membership</a>{/* <div className='registerFreetrial'><a href='/wenaturalists-pro'>Register for a Free Trial</a></div> */}</>,
                })
            })
        }else{
            window.$('#addAdminModal').modal('show');
        }


    }



    removeUserToGroup(evt, data) {
        const userList = this.state.userList;
        userList.push(data);
        let array = [...this.state.selectedList];
        let index = array.indexOf(data)
        if (index !== -1) {
            array.splice(index, 1);
            this.setState({selectedList: array});
        }
        this.setState({userList: userList});
        evt.preventDefault();
    }



    getCurrentAdministrations = () => {
        axios({
            method: 'get',
            url: process.env.REACT_APP_userServiceURL + '/admin/getCurrentAdmininstrations/'
                 +this.state.userData.userId+ '/'+ this.props.projectId,
            headers: {'Content-Type': 'application/json'},
            withCredentials: true
        }).then(response => {
            if (response && response.data && response.data.body && response.data.message === 'Success!') {

                this.setState({
                    'administrations': response.data.body
                });
            }
        }).catch((err) => {
            console.log(err);
        });
    };

    getPendingInvitations = () => {
        axios({
            method: 'get',
            url: process.env.REACT_APP_userServiceURL + '/admin/getPendingInvitations/'
                +this.state.userData.userId+ '/'+ this.props.projectId+'?page=0&size=10',
            headers: {'Content-Type': 'application/json'},
            withCredentials: true
        }).then(response => {
            if (response && response.data && response.data.body && response.data.message === 'Success!') {

                this.setState({
                    'pendingInvitations': response.data.body
                });
            }
        }).catch((err) => {
            console.log(err);
        });
    };

    getAdminHistory = () => {
        axios({
            method: 'get',
            url: process.env.REACT_APP_userServiceURL + '/admin/getAdminHistory/'
                +this.state.userData.userId+ '/'+ this.props.projectId+'?page=0&size=10',
            headers: {'Content-Type': 'application/json'},
            withCredentials: true
        }).then(response => {
            if (response && response.data && response.data.body && response.data.message === 'Success!') {

                this.setState({
                    'adminHistory': response.data.body
                });
            }
        }).catch((err) => {
            console.log(err);
        });
    };



    componentWillUnmount() {
        this.state.inviteeList && this.state.inviteeList.map((user, index) => {
            if (window.$('#Withdraw' + user.id)) {
                window.$('#Withdraw' + user.id).modal('hide');
            }
        })
        window.$('#addAdminModal').modal('hide');
        window.$('.modal-backdrop').remove();
    }

    removeSelectedUserConnect = () => {
        this.setState({
            user:{}, radioChecked:false, isDisable : true, userId : ''
        })
    }


    render() {
        const parent  = { height: '149px'}
        const lowercasedSearch = this.state.searchMembers.toLowerCase();
        const searchedList = this.state.config && this.state.config.connectedUserList && this.state.config.connectedUserList.filter(item=>{
            return Object.keys(item).some(key=>
                item.username.toLowerCase().includes(lowercasedSearch)
            );
        });
        return (
            <div className="col-md-9">
                <div className="projectinn nothidden projdetailscont">
                    <Banner {...this.props} />
                    {this.props.projectDetail && !_.isUndefined(this.props.projectDetail.demolished) && this.props.projectDetail.demolished === false &&
                        <TopBar {...this.props} />
                    }

                    {this.props.userId && <OrganizationAdmin userId={this.props.userId} />}

                    <div className="projdetlswrap">

                        <div className="row">
                            <div  className="col-lg-9">
                                <div className="projAdminWrapInn">
                                    <div className="projAdminCurrentAdmin">
                                        <h2 className="title">Current Administration</h2>
                                        <div className="projAdminCurrentAdminScroll">
                                            <HorizontalScroll className={"myCirclecarousel"} style={parent} reverseScroll>

                                                {this.state.administrations && this.state.administrations.map((data,index)=>{
                                                    return <div className="item" key={index}>
                                                        <div className="currentAdminblk">
                                                            <figure className="users" onClick={(e) => {
                                                                                e.preventDefault();
                                                                                this.redirectToProfile(data.customUrl)
                                                                            }} style={{cursor: 'pointer'}}><img
                                                                src={data.originalProfileImage != null ? getCDNUrl(this.getOptimizedImage(data)) : data.userType !== "COMPANY" ? "https://cdn.dscovr.com/images/users1.png" : "https://cdn.dscovr.com/images/DefaultBusiness.png"}

                                                                alt=""/></figure>
                                                            <div className="currentAdminblkinfo">
                                                                <h5><Link to={"/profile/" + data.customUrl} style={{cursor: 'pointer'}}>{data.username}</Link></h5>
                                                                <span className="country">{data.country}</span>
                                                                <span className="persona"><span>{data.adminType}</span></span>
                                                                <p>Since {mappingUtils.getAdminCustomDate(data.acceptedDate)}</p>
                                                            </div>
                                                            {data.canTransferSuperAdminRight !== 'NOT REQUIRED' && this.props.projectDetail?.userId === this.state.userData.userId &&
                                                                <div className="contxmenu">
                                                                    <button type="button" className="btn"
                                                                            data-toggle="dropdown" aria-haspopup="true"
                                                                            aria-expanded="false"><i className="iKebab"/>
                                                                    </button>
                                                                    {data.canTransferSuperAdminRight === 'REQUIRED' ?
                                                                        <div className="dropdown-menu fadeIn animated">
                                                                            <a href="javascript:void(0)"
                                                                            onClick={this.openAdminTransferModel}
                                                                            className="dropdown-item">Transfer Rights</a>
                                                                        </div> :
                                                                        (data.canTransferSuperAdminRight === 'Transfer Rights Verification Pending'?
                                                                        <div className="dropdown-menu fadeIn animated">
                                                                            <a href={'#withdrawTransferInvite'}
                                                                            data-toggle="modal"
                                                                            className="dropdown-item">Transfer Rights Verification Pending</a>


                                                                        </div>:
                                                                        <div className="dropdown-menu fadeIn animated">
                                                                            <a href={'#withdrawTransferInvite'}
                                                                            data-toggle="modal"
                                                                            className="dropdown-item">Transfer Right
                                                                                Request Pending</a>


                                                                        </div>)
                                                                    }
                                                                </div>
                                                            }


                                                            {data.canRemoveAdmin &&
                                                            <div className="contxmenu">
                                                                <button type="button" className="btn"
                                                                        data-toggle="dropdown" aria-haspopup="true"
                                                                        aria-expanded="false"><i className="iKebab"/>
                                                                </button>
                                                                <div className="dropdown-menu fadeIn animated">
                                                                    <a onClick={e => {
                                                                        e.preventDefault();
                                                                        this.openRemoveConfirmPop(data)
                                                                    }}
                                                                       className="dropdown-item"><i
                                                                        className="iRemove_Admin"/> Remove Admin</a>
                                                                </div>


                                                            </div>

                                                            }

                                                        </div>
                                                    </div>
                                                })}

                                            </HorizontalScroll>
                                        </div>

                                        <div className="modal fade dgpopup confirmpop"
                                             id={'withdrawTransferInvite'}
                                             tabIndex="-1" role="dialog"
                                             aria-labelledby="exampleModalLabel"
                                             aria-hidden="true" data-backdrop="static"
                                             data-keyboard="false">
                                            <div className="modal-dialog" role="document">
                                                <div className="modal-content">
                                                    <button type="button" className="close"
                                                            data-dismiss="modal"
                                                            aria-label="Close">
                                                                                    <span
                                                                                        aria-hidden="true">&times;</span>
                                                    </button>
                                                    <div
                                                        className="confirm-popup-modal-body">
                                                        Are you sure you want to withdraw
                                                        this transfer invite?
                                                    </div>
                                                    <div
                                                        className="modal-footer confirm-popup-modal-footer">
                                                        <button type="button"
                                                                onClick={e => {
                                                                    e.preventDefault();
                                                                    this.withDrawTransferInviteRequest()
                                                                }}
                                                                className="btn btn-primary">Yes
                                                        </button>
                                                        <button type="button"
                                                                className="btn btn-secondary"
                                                                data-dismiss="modal">No
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        {this.state.config && this.state.config.canAddAdmin &&
                                        <div className="projAdminCurrentAdminBottom">
                                            <a onClick={this.handleAddAdmin}
                                               className="btn addAdminBtn"><i className="iAddUser"></i> Add Admin</a>
                                        </div>
                                        }
                                    </div>

                                    <div className="projAdminInvitHistory">
                                        <div className="projAdminInvitHistoryTab">
                                            <ul id="tabs" className="nav">
                                                <li className="nav-item"><a href="#adminHistory" data-toggle="tab" className="active" onClick={() => {CleverTapUtils.eventClick({}, "View Admin History");}}>Admin History</a></li>
                                                <li className="nav-item"><a href="#adminInvitations" data-toggle="tab" onClick={() => {CleverTapUtils.eventClick({}, "View Invitations");}}>Invitations</a></li>
                                            </ul>
                                        </div>

                                        <div id="tabsContent" className="tab-content projgeneralsec">
                                            <div id="adminHistory" className="tab-pane fade  active show">
                                                <div id="scrollableDiv">
                                                    {this.state.adminHistory && this.state.adminHistory.content && this.state.adminHistory.content.map((data,index)=>{
                                                        return <div className="adminHistRow" key={index}>
                                                            <figure className="users"><Link
                                                                to={"/profile/" + data.customUrl}
                                                                style={{cursor: 'pointer'}}>
                                                                <img
                                                                    src={data.originalProfileImage != null ? getCDNUrl(this.getOptimizedImage(data)) : "https://cdn.dscovr.com/images/users1.png"}
                                                                alt=""/></Link></figure>
                                                            <div className="userinfo">
                                                                <h5><Link
                                                                    to={"/profile/" + data.customUrl}
                                                                    style={{cursor: 'pointer'}}>{data.username}</Link></h5>
                                                                <span className="address">{data.country}</span>
                                                            </div>
                                                            <div className="adminHistYear">
                                                                <p>Since <span>{mappingUtils.getAdminCustomDate(data.acceptedDate)}</span></p>
                                                                <p>to <span>{mappingUtils.getAdminCustomDate(data.revokedDate)}</span></p>
                                                            </div>
                                                        </div>
                                                    })}
                                                    {this.state.adminHistory && this.state.adminHistory.content && this.state.adminHistory.content.length === 0 &&
                                                        <div className="row">
                                                            <div className="zdata col-12">
                                                                <div className="desc">
                                                                    <p style={{margin: '0'}}>No History Found</p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    }


                                                </div>
                                            </div>
                                            <div id="adminInvitations" className="tab-pane fade">
                                                <div id="scrollableDiv">
                                                    <div className="row">
                                                        {this.state.pendingInvitations && this.state.pendingInvitations.content && this.state.pendingInvitations.content.map((data,index)=>{
                                                            return <div className="col-md-6" key={index}>
                                                                <div className="adminHistRow">
                                                                    <figure className="users"><Link
                                                                        to={"/profile/" + data.customUrl}
                                                                        style={{cursor: 'pointer'}}>
                                                                        <img
                                                                            src={data.originalProfileImage != null ? getCDNUrl(this.getOptimizedImage(data)) : "https://cdn.dscovr.com/images/users1.png"}
                                                                        alt=""/></Link></figure>
                                                                    <div className="userinfo">
                                                                        <h5><Link
                                                                            to={"/profile/" + data.customUrl}
                                                                            style={{cursor: 'pointer'}}>{data.username}</Link></h5>
                                                                        <span
                                                                            className="address">{data.country}</span>
                                                                    </div>
                                                                    {data.status === 'Pending' ?
                                                                        <div className="adminHistYear">
                                                                            <a href={'#withdrawInvite' + data.userId}
                                                                               data-toggle="modal"
                                                                               className="cancelinvite btn">Withdraw
                                                                                Invite</a>
                                                                        </div> :
                                                                        <div className="adminHistYear"><span className="accept">
                                                                            {/* <i className="iFollowTick"/> */}
                                                                            {data.status}</span></div>
                                                                    }
                                                                    <div className="modal fade dgpopup confirmpop"
                                                                         id={'withdrawInvite'+data.userId}
                                                                         tabIndex="-1" role="dialog"
                                                                         aria-labelledby="exampleModalLabel"
                                                                         aria-hidden="true" data-backdrop="static"
                                                                         data-keyboard="false">
                                                                        <div className="modal-dialog" role="document">
                                                                            <div className="modal-content">
                                                                                <button type="button" className="close"
                                                                                        data-dismiss="modal"
                                                                                        aria-label="Close">
                                                                                    <span
                                                                                        aria-hidden="true">&times;</span>
                                                                                </button>
                                                                                <div
                                                                                    className="confirm-popup-modal-body">
                                                                                    Are you sure you want to withdraw
                                                                                    this invite?
                                                                                </div>
                                                                                <div
                                                                                    className="modal-footer confirm-popup-modal-footer">
                                                                                    <button type="button"
                                                                                            onClick={e => {
                                                                                                e.preventDefault();
                                                                                                this.withDrawInviteRequest(data.userId)
                                                                                            }}
                                                                                            className="btn btn-primary">Yes
                                                                                    </button>
                                                                                    <button type="button"
                                                                                            className="btn btn-secondary"
                                                                                            data-dismiss="modal">No
                                                                                    </button>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                        })}

                                                        {this.state.pendingInvitations && this.state.pendingInvitations.content && this.state.pendingInvitations.content.length === 0 &&
                                                        <div className="zdata col-12">
                                                            <div className="desc">
                                                                <p style={{margin: '0'}}>No Pending Invitations Found</p>
                                                            </div>
                                                        </div>
                                                        }

                                                    </div>
                                                </div>
                                            </div>


                                        </div>
                                    </div>
                                </div>
                            </div>
                            <RightPanel {...this.props}/>
                            <div id="addAdminModal" className="chatlistpop modal fade dgpopup" tabIndex="-1"
                                 data-backdrop="static" data-keyboard="false">
                                <div className="modal-dialog">
                                    <div className="modal-content">
                                        <div className="modal-body">
                                            {
                                                this.state.isModalLoading ?
                                                    <div style={{
                                                        width: '100%', height: '100%', position: 'fixed', top: 0, left: 0,
                                                        display: 'flex', alignItems: 'center', justifyContent: 'center'
                                                    }}>
                                                        <Loader
                                                            type="Grid"
                                                            color="#dcde63"
                                                            height={60}
                                                            width={60}
                                                            timeout={8000}
                                                        />
                                                    </div>
                                                    : <div className="forwcontwrap">
                                                        <div className="forwcontwraptop">
                                                            <h4>Select Users</h4>
                                                            <form action="" onSubmit="return false;">
                                                                <input type="text" className="form-control"
                                                                       placeholder="Type Connect Name"
                                                                       id="searchGroupByChars"
                                                                       onKeyUp={(evt) => this.keyPressedBySearchGroupByChars(evt)}/>
                                                                <button className="btn btnsearch" type="button" onClick={(e) => {
                                                                    e.preventDefault()
                                                                }}>
                                                                    <i className="fa fa-search" aria-hidden="true"/>
                                                                </button>
                                                            </form>
                                                            {this.state.subscriptionError &&
                                                            <span className="login-feedback-error mt-2 mb-2">{this.state.subscriptionErrorMessage}</span>
                                                            }
                                                            {this.state.selectedList && this.state.selectedList.length > 0 ?
                                                                <HorizontalScroll reverseScroll>
                                                                    <div className="srchlist">
                                                                        {this.state.selectedList && this.state.selectedList.map((data, index) => {

                                                                                return <div key={index} className="srchlistblk">
                                                                                    <figure className="img"><img
                                                                                        src={data.originalProfileImage != null ? getCDNUrl(this.getOptimizedImage(data)) : "https://cdn.dscovr.com/images/users1.png"}
                                                                                        alt=""/>
                                                                                    </figure>
                                                                                    <span>{data.username} </span>
                                                                                    {
                                                                                        index !== this.state.userData.userId && (
                                                                                            <i className="iCross"
                                                                                               onClick={(e) => this.removeUserToGroup(e, data)}/>
                                                                                        )
                                                                                    }
                                                                                </div>
                                                                            }
                                                                        )}
                                                                    </div>
                                                                </HorizontalScroll> : null}
                                                            <Scrollbars
                                                                className={'forwcontlistmain contactlist'}
                                                                autoHide
                                                                autoHeight
                                                                autoHeightMin={0}
                                                                autoHeightMax={322}
                                                                universal={true}
                                                                renderTrackHorizontal={props => <div {...props} className="track-horizontal"/>}
                                                                renderTrackVertical={props => <div {...props} className="track-vertical"/>}
                                                            >
                                                                <ul>
                                                                    {
                                                                        this.state.userList && this.state.userList
                                                                            .filter(data =>
                                                                                data.id !== this.state.userData.userId
                                                                                && (this.state.searchUserByChars === ''
                                                                                || (this.state.searchUserByChars && data.username && data.username.toLowerCase().includes(this.state.searchUserByChars.toLowerCase()))
                                                                                ))
                                                                            .map((data, index) => {

                                                                                    return <li key={index} style={{ pointerEvents: this.state.selectedList.length >= this.state.config.noOfAdminCanBeAdded?'none':'',opacity: this.state.selectedList.length >= this.state.config.noOfAdminCanBeAdded?0.6:'' }}  >
                                                                                        <a href="javascript:void(0)"

                                                                                           onClick={(e) => this.addUserToGroup(e, data)}>
                                                                                            <figure className="users"><img
                                                                                                src={data.originalProfileImage != null ? getCDNUrl(this.getOptimizedImage(data)) : "https://cdn.dscovr.com/images/users1.png"}

                                                                                                alt=""/></figure>
                                                                                            <div>
                                                                                                <div
                                                                                                    className="name">{data.username}  </div>
                                                                                            </div>
                                                                                        </a>
                                                                                    </li>
                                                                                }
                                                                            )
                                                                    }
                                                                </ul>
                                                            </Scrollbars>
                                                        </div>

                                                        <div className="forwcontwrapbott">
                                                            <div className="itemscount">{this.state.selectedList.length} Selected</div>
                                                            <div>
                                                                <button className="butt btnsecondary close" data-dismiss="modal"
                                                                        id="forwardMessageModalCloseBtn"
                                                                        onClick={this.clearUsers.bind(this)}>Close
                                                                </button>
                                                                <button disabled={this.state.selectedList.length === 0}
                                                                        className="btn"
                                                                        onClick={this.handleUsersSelectSubmit}>Add Admin
                                                                </button>

                                                            </div>
                                                        </div>
                                                    </div>
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="modal fade dgpopup confirmpop"
                                 id={'removeAdminConfirmPop'}
                                 tabIndex="-1" role="dialog"
                                 aria-labelledby="exampleModalLabel"
                                 aria-hidden="true" data-backdrop="static"
                                 data-keyboard="false">
                                <div className="modal-dialog" role="document">
                                    <div className="modal-content">
                                        <button type="button" className="close"
                                                data-dismiss="modal"
                                                aria-label="Close">
                                                                                    <span
                                                                                        aria-hidden="true">&times;</span>
                                        </button>
                                        <div
                                            className="confirm-popup-modal-body">
                                            Are you sure you want to remove {this.state.adminInfo.username} as an admin for the{' '}
                                            {this.props.projectDetail && this.props.projectDetail.project && mappingUtils.getProjectTypeValue(this.props.projectDetail.project.type)} <span></span><span>
                                            {this.props.projectDetail && this.props.projectDetail.project && this.props.projectDetail.project.title}</span>?
                                        </div>
                                        <div
                                            className="modal-footer confirm-popup-modal-footer">
                                            <button type="button"
                                                    onClick={e => {
                                                        e.preventDefault();
                                                        this.removeAdmin()
                                                    }}
                                                    className="btn btn-primary">Yes
                                            </button>
                                            <button type="button"
                                                    className="btn btn-secondary"
                                                    data-dismiss="modal">No
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div id="assignsinglepopAdmin" className="chatlistpop modal fade dgpopup" data-backdrop="static" tabIndex="-1" role="dialog" aria-hidden="true">
                                <div className="modal-dialog">
                                    <div className="modal-content">
                                        <div className="modal-body">
                                            <div className="forwcontwrap">
                                                <div className="forwcontwraptop">
                                                    <h4>Select Connect</h4>
                                                    <div className="forwcontbodywrap">
                                                        <div className="addmemberwrap">
                                                            <div className="search2"><input type="text" className="form-control"
                                                                                            placeholder="Search Connect" value={this.state.searchMembers}
                                                                                            onChange={this.handleSearch}/>
                                                            </div>
                                                        </div>
                                                        {this.state.user && Object.keys(this.state.user).length > 0 && <div class="srchlist">
                                                            <div class="srchlistblk">
                                                                <figure class="img">
                                                                <img src={this.state.user && this.state.user.originalProfileImage ? getCDNUrl(this.getOptimizedImage(this.state.user)) : "https://cdn.dscovr.com/images/users1.png"}
                                                                        alt=""/>
                                                                </figure>
                                                                <span>{this.state.user && this.state.user.username}</span><i class="iCross" onClick={(e) => this.removeSelectedUserConnect()}/>
                                                            </div>
                                                        </div>}

                                                        <Scrollbars
                                                            className={'forwcontlistmain contactlist'}
                                                            autoHide
                                                            autoHeight
                                                            autoHeightMin={0}
                                                            autoHeightMax={230}
                                                            universal={true}
                                                            renderTrackHorizontal={props => <div {...props} className="track-horizontal"/>}
                                                            renderTrackVertical={props => <div {...props} className="track-vertical"/>}
                                                        >
                                                            <ul>

                                                                {searchedList && searchedList.map((user,userId)=>{
                                                                    return <li key={userId} onClick={(e)=>this.addMember(user)}>
                                                                        <a href="javascript:void(0)" className="radio-container">
                                                                            <figure className="users">
                                                                                <img src={(user && user.originalProfileImage) ?  getCDNUrl(getOptimizedImage(user,"originalProfileImage")) : 'https://cdn.dscovr.com/images/users1.webp'} onError={(e)=>{e.target.onerror = null; e.target.src="https://cdn.dscovr.com/images/users1.png"}} alt="" />
                                                                            </figure>
                                                                            <div>
                                                                                <div className="name">{user.username}</div>
                                                                            </div>
                                                                            <input type="radio"  checked={this.state.userId === user.id} name="radio"/>
                                                                            <span className="radio-checkmark"/>
                                                                        </a>
                                                                    </li>
                                                                })}


                                                            </ul>
                                                        </Scrollbars>
                                                    </div>
                                                </div>
                                                <div className="forwcontwrapbott justify-content-end">
                                                    <div>
                                                        <button type="button" className="btn btn-primary" disabled={this.state.isDisable} onClick={this.transferAdminRightRequest}>Submit
                                                        </button>
                                                        <button type="button" className="btn btn-cancel" onClick={this.cancelUser} >Cancel
                                                        </button>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        setProjectDetails: (details) => dispatch(setProjectDetails(details)),
    };
};


export default connect(null, mapDispatchToProps)(ProjectAdminContainer);
